<template>
  <div class="download-view" @click="device_hide">
    <div class="download-view-content">
      <div class="u-flex u-col-center u-row-center">
        <img class="logo" :src="logo" alt="" />
        <div class="bold font-46 u-m-l-15">{{ logo_text }}</div>
      </div>
      <div class="text-center u-m-t-35 font-36 bold">
        <span>{{ sub }}</span>
        <span class="sub-other cursor">{{ sub_other }}</span>
      </div>
      <div class="log-view u-m-t-50">
        <div
          class="u-flex u-row-between u-m-b-30"
          v-for="(log, index) in logList"
          :key="index"
        >
          <!-- <div class="cursor" @click="apk_url(log.apk_url)">{{ log.name }}</div>
          <div class="cursor" @click="apk_url(log.apk_url)">
            {{ log.createtime }}
          </div> -->
          <div>{{ log.name }}</div>
          <div>
            {{ log.createtime }}
          </div>
        </div>
      </div>
      <span class="cursor bold font-18">{{ more_text }}</span>
      <div class="u-flex u-row-between u-m-t-70">
        <div
          class="download-box-item u-flex u-row-center u-col-center"
          v-for="(device, index) in downloadList"
          :key="index"
          @mouseover="device.show = true"
        >
          <img class="download-box-icon" :src="device.img" alt="" />
          <div>{{ device.title }}</div>
          <div
            class="download-dialog"
            v-if="device.show"
            @mouseover="device.show = true"
          >
            <img
              @click="download(index)"
              v-if="index > 1"
              class="download-dialog-icon"
              :src="down_pic"
              alt=""
            />
            <img
              v-else
              :src="!index ? android_qrcode : ios_qrcode"
              alt=""
              style="width: 99px; height: 101px"
            />
            <div @click="download(index)">
              {{ index > 1 ? "点击下载" : "扫码下载" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode";
export default {
  name: "DownloadView",
  data() {
    return {
      logo: require("@/assets/download/logo.png"),
      logo_text: "纳软工程助手",
      sub: "下载用户端一键开启",
      sub_other: "更多功能",
      logList: [],
      more_text: "更多日志 >",
      downloadList: [
        {
          title: "Android",
          img: require("@/assets/download/android.png"),
          show: false,
        },
        {
          title: "I0S",
          img: require("@/assets/download/apple.png"),
          show: false,
        },
        {
          title: "Windows",
          img: require("@/assets/download/window.png"),
          show: false,
        },
      ],
      down_pic: require("@/assets/download/dow.png"),
      android_qrcode: "",
      ios_qrcode: "",
      windows_link: "",
    };
  },
  async mounted() {
    // this.android_qrcode = await this.initQrcode('android');
    // this.ios_qrcode = await this.initQrcode('ios');
    this.fetchWebsiteConfig();
    this.getSysBaseInfo();
  },
  methods: {
    apk_url(url) {
      window.open(url);
    },
    download(index) {
      if (index == 2) {
        // console.log(this.$apiBaseUrl);
        window.open(this.$apiBaseUrl + "/dlexe.php?url=" + this.windows_link);
        // this.downloadFile(this.windows_link, "NaruanSetup.exe");
      }
    },
    // downloadFile(url, fileName) {
    //   // console.log(fileName);
    //   const link = document.createElement("a");
    //   link.style.display = "none";
    //   link.setAttribute("href", url);
    //   link.setAttribute("download", fileName);
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // },
    device_hide() {
      this.downloadList.forEach((item) => {
        item.show = false;
      });
    },
    initQrcode(text) {
      return new Promise((resolve, reject) => {
        QRCode.toDataURL(
          text,
          {
            margin: 2,
          },
          (err, url) => {
            if (!err) {
              resolve(url);
            } else {
              reject();
            }
          }
        );
      });
    },
    async fetchWebsiteConfig() {
      const response = await fetch(
        this.$apiBaseUrl + "/api/website/website_conf"
      );
      const data = await response.json();
      this.data = data.data;
      this.android_qrcode = data.data.android_image;
      this.ios_qrcode = data.data.ios_image;
      this.windows_link = data.data.windows_link;
      console.log(this.windows_link);
    },
    async getSysBaseInfo() {
      const response = await fetch(
        this.$apiBaseUrl + "/api/index/getSysBaseInfo"
      );
      const data = await response.json();
      console.log(data.data);
      this.logList = data.data.apk_list;
    },
  },
};
</script>
<style lang="scss" scoped>
.download-view {
  height: 774px;
  background-image: url("../assets/download/back-img.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 42px;
  .cursor {
    cursor: pointer;
  }
  &-content {
    width: 630px;
    margin: 0 auto;
    color: #fff;
    padding-top: 120px;
    .logo {
      height: 70px;
    }
    .sub-other {
      color: #fece88;
      display: inline-block;
      margin-left: 15px;
    }
    .log-view {
      color: #eff7ff;
      font-size: 18px;
    }
    .download-box-item {
      width: 136px;
      height: 136px;
      background: rgba(255, 255, 255, 0.3);
      box-shadow: 0px 0px 20px 0px rgba(36, 82, 131, 0.1);
      border-radius: 50%;
      flex-direction: column;
      cursor: pointer;
      position: relative;
    }
    .download-box-icon {
      width: 40px;
      margin-bottom: 10px;
    }
    .download-dialog {
      width: 136px;
      height: 148px;
      background-color: #fff;
      border-radius: 8px;
      position: absolute;
      top: -168px;
      color: #333;
      font-size: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      // 新增三角形指示器
      &::after {
        content: "";
        position: absolute;
        bottom: -10px; // 向下偏移
        left: 50%;
        transform: translateX(-50%);
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 10px solid #fff; // 颜色与弹窗背景一致
      }
      &-icon {
        width: 44px;
      }
    }
  }
}
</style>
